/* Native forms remain available if JavaScript or the network is unavailable. */
(() => {
  'use strict';
  const config = window.Nordic || {};
  const root = config.root || '/';
  const endpoint = name => `${root.replace(/\/$/, '')}/cart/${name}.js`;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  let busy = false;
  let cartOpener = null;
  let cartNoteDraft = null;
  const announce = message => { const live = $('[data-live-status]'); if (live) live.textContent = message; };
  const errorText = data => typeof data?.description === 'string' ? data.description : typeof data?.message === 'string' ? data.message : config.strings?.error || 'İşlem tamamlanamadı.';

  function openCart(opener) {
    const dialog = $('[data-cart-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') { window.location.assign(config.cart || `${root}cart`); return; }
    if (opener) cartOpener = opener;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('dialog-open');
  }
  function closeCart() {
    const dialog = $('[data-cart-dialog]');
    if (dialog?.open) dialog.close();
    document.body.classList.remove('dialog-open');
    if (cartOpener?.isConnected) cartOpener.focus();
  }
  function installCart(html) {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newDialog = $('[data-cart-dialog]', parsed);
    const oldDialog = $('[data-cart-dialog]');
    if (!newDialog || !oldDialog) return false;
    const wasOpen = oldDialog.open;
    // Keep the modal node, its focus trap and the current keyboard focus position.
    const active = document.activeElement;
    const activeId = oldDialog.contains(active) ? active.id : '';
    const scrollTop = $('.drawer-body', oldDialog)?.scrollTop || 0;
    const noteValue = cartNoteDraft ?? $('[name="note"]', oldDialog)?.value;
    oldDialog.innerHTML = newDialog.innerHTML;
    if (noteValue !== undefined && noteValue !== null) { const noteField = $('[name="note"]', oldDialog); if (noteField) noteField.value = noteValue; }
    oldDialog.dataset.count = newDialog.dataset.count;
    $$('[data-cart-count]').forEach(el => { el.textContent = newDialog.dataset.count || '0'; });
    if (wasOpen) {
      const restore = activeId && document.getElementById(activeId);
      const restoredQuantity = restore?.matches('[data-line-quantity]') ? restore : null;
      if (restoredQuantity) restoredQuantity.focus();
      else (restore || $('[data-close-dialog]', oldDialog))?.focus();
      const body = $('.drawer-body', oldDialog); if (body) body.scrollTop = scrollTop;
    }
    return true;
  }
  function setBusy(value) {
    busy = value;
    document.body.toggleAttribute('data-cart-busy', value);
  }
  async function cartRequest(name, data) {
    const response = await fetch(endpoint(name), {
      method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(errorText(result));
    return result;
  }
  async function addProduct(form, opener) {
    if (busy) return;
    const message = $('[data-form-message]', form);
    const submit = opener || $('button[type=submit]', form);
    if (message) message.textContent = '';
    if (form.dataset.invalidSelection === 'true') {
      if (message) message.textContent = config.strings?.unavailable;
      $('[data-option-select]', form)?.focus();
      return;
    }
    if (!form.reportValidity()) return;
    setBusy(true);
    form.setAttribute('aria-busy', 'true');
    try {
      const data = new FormData(form);
      data.set('sections', 'cart-drawer');
      data.set('sections_url', window.location.pathname);
      const result = await cartRequest('add', data);
      announce(config.strings?.added || 'Ürün sepete eklendi.');
      if (config.cartType === 'page' || !installCart(result.sections?.['cart-drawer'])) {
        window.location.assign(config.cart || `${root}cart`);
      } else { openCart(submit); }
    } catch (error) {
      if (message) message.textContent = error.message || config.strings?.error;
      announce(error.message);
    } finally { setBusy(false); form.removeAttribute('aria-busy'); }
  }
  async function addBundle(form) {
    if (busy) return;
    const message = $('[data-form-message]', form);
    const submit = $('button[type=submit]', form);
    if (message) message.textContent = '';
    if (!form.reportValidity()) return;
    const mainId = Number($('[data-bundle-main-id]', form)?.value);
    const secondId = Number($('select', form)?.value);
    if (!mainId || !secondId) return;
    const mainForm = $('[data-main-product-form]', form.closest('[data-product-section]'));
    if (mainForm && (!mainForm.reportValidity() || mainForm.dataset.invalidSelection === 'true')) return;
    const mainData = mainForm ? new FormData(mainForm) : new FormData();
    const mainProperties = {};
    for (const [key, value] of mainData.entries()) {
      const property = key.match(/^properties\[(.+)\]$/);
      if (property && value) mainProperties[property[1]] = value;
    }
    const mainItem = { id: mainId, quantity: Number(mainData.get('quantity')) || 1, properties: mainProperties };
    const sellingPlan = mainData.get('selling_plan');
    if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);
    setBusy(true);
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(endpoint('add'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [mainItem, { id: secondId, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(errorText(result));
      announce(config.strings?.added || 'Ürün sepete eklendi.');
      if (config.cartType === 'page' || !installCart(result.sections?.['cart-drawer'])) {
        window.location.assign(config.cart || `${root}cart`);
      } else { openCart(submit); }
    } catch (error) {
      if (message) message.textContent = error.message || config.strings?.error;
      announce(error.message);
    } finally { setBusy(false); form.removeAttribute('aria-busy'); }
  }
  async function changeLine(key, quantity) {
    if (busy) return;
    const error = $('[data-drawer-error]');
    if (error) error.textContent = '';
    setBusy(true);
    try {
      const data = new FormData();
      data.set('id', key); data.set('quantity', String(quantity));
      data.set('sections', 'cart-drawer'); data.set('sections_url', window.location.pathname);
      const result = await cartRequest('change', data);
      if (!installCart(result.sections?.['cart-drawer'])) window.location.assign(config.cart || `${root}cart`);
    } catch (failure) {
      if (error?.isConnected) error.textContent = failure.message || config.strings?.error;
      announce(failure.message);
      // Recover the real server quantities after an unavailable stock request.
      try {
        const url = new URL(window.location.href); url.search = ''; url.searchParams.set('sections', 'cart-drawer');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (response.ok) { const rendered = await response.json(); installCart(rendered['cart-drawer']); const current = $('[data-drawer-error]'); if (current) current.textContent = failure.message; }
      } catch (_) { /* The visible error and native cart link remain available. */ }
    } finally { setBusy(false); }
  }
  function showMedia(gallery, mediaId) {
    if (!gallery) return;
    const target = $(`[data-media-id="${CSS.escape(String(mediaId))}"]`, gallery);
    if (!target) return;
    $$('[data-media-id]', gallery).forEach(slide => {
      const hide = slide !== target;
      slide.hidden = hide;
      if (hide) {
        $$('video', slide).forEach(video => video.pause());
        // Reload an inactive iframe once to stop any playing external media.
        $$('iframe', slide).forEach(frame => { if (frame.dataset.wasActive) { const src = frame.src; frame.src = src; delete frame.dataset.wasActive; } });
      } else $$('iframe', slide).forEach(frame => { frame.dataset.wasActive = 'true'; });
    });
    $$('[data-media-target]', gallery).forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === String(mediaId))));
  }
  const variantCache = new WeakMap();
  const stickyObservers = new WeakMap();
  const synchronisingVariant = new WeakSet();
  function variantsFor(section) {
    if (!section) return [];
    if (!variantCache.has(section)) {
      try { variantCache.set(section, JSON.parse($('[data-variants]', section)?.textContent || '[]')); }
      catch (_) { variantCache.set(section, []); }
    }
    return variantCache.get(section);
  }
  function refreshOptionAvailability(section, variants) {
    const selects = $$('[data-option-select]', section);
    const chosen = selects.map(select => select.value);
    selects.forEach((select, index) => {
      Array.from(select.options).forEach(option => {
        const matching = variants.filter(v => v.options?.every((value, i) => value === (i === index ? option.value : chosen[i])));
        const label = option.dataset.optionLabel || option.value;
        option.textContent = label + (!matching.length ? ` · ${config.strings?.optionUnavailable || 'Birlikte sunulmuyor'}` : !matching.some(v => v.available) ? ` · ${config.strings?.soldOut || 'Tükendi'}` : '');
      });
    });
  }
  function updateVariant(section, id, changeUrl = true, syncOptions = true) {
    const variants = variantsFor(section);
    const variant = variants.find(v => String(v.id) === String(id));
    const form = $('[data-main-product-form]', section);
    if (form) form.dataset.invalidSelection = String(!variant);
    const available = Boolean(variant?.available);
    $$('[data-variant-select]', section).forEach(select => { select.value = variant ? String(variant.id) : ''; });
    if (variant && syncOptions) $$('[data-option-select]', section).forEach(select => { select.value = variant.options[Number(select.dataset.optionIndex)]; });
    refreshOptionAvailability(section, variants);
    $$('[data-product-price]', section).forEach(price => { price.innerHTML = variant?.price || '—'; });
    $$('[data-product-compare]', section).forEach(compare => { compare.hidden = !variant?.compare; compare.innerHTML = variant?.compare || ''; });
    $$('[data-add-button]', section).forEach(button => {
      button.disabled = !available;
      const label = $('[data-add-label]', button);
      if (label) label.textContent = !variant ? config.strings?.checkOptions : available ? button.dataset.label || config.strings?.add : config.strings?.soldOut;
    });
    $$('[data-dynamic-checkout]', section).forEach(el => { el.hidden = !available; });
    $$('[data-bundle-main-id]', section).forEach(input => { input.value = variant ? String(variant.id) : ''; });
    $$('[data-bundle-form] button[type=submit]', section).forEach(button => { button.disabled = !available; });
    $$('[data-sticky-add]', section).forEach(button => {
      button.disabled = Boolean(variant && !available);
      button.type = variant ? 'submit' : 'button';
      button.textContent = !variant ? button.dataset.reviewLabel || config.strings?.checkOptions : available ? button.dataset.label || config.strings?.add : config.strings?.soldOut;
    });
    const inventory = $('[data-inventory]', section);
    if (inventory) inventory.textContent = !variant ? config.strings?.unavailable : available ? inventory.dataset.available || config.strings?.available : inventory.dataset.soldout || config.strings?.soldOut;
    const status = $('[data-selection-status]', section);
    if (status) {
      status.textContent = !variant ? config.strings?.unavailable : !available ? config.strings?.variantSoldOut : config.strings?.availableSelection;
      status.classList.toggle('selection-warning', !available);
    }
    const productId = section.dataset.productId;
    const rows = [...$$('[data-dimensions-row]', section), ...$$(`[data-dimensions-product="${CSS.escape(productId || '')}"]`)];
    new Set(rows).forEach(row => {
      row.hidden = !variant?.dimensions;
      const value = $('[data-selected-dimensions]', row);
      if (value) value.innerHTML = variant?.dimensions || '';
    });
    const quantity = $('[name=quantity]', form || section);
    if (quantity && variant) {
      const min = variant.min || 1, step = variant.step || 1;
      quantity.min = min; quantity.step = step;
      if (variant.max !== null && variant.max !== undefined) quantity.max = variant.max; else quantity.removeAttribute('max');
      let current = min + Math.ceil((Math.max(Number(quantity.value) || min, min) - min) / step) * step;
      if (variant.max) current = Math.min(current, min + Math.floor((variant.max - min) / step) * step);
      quantity.value = current;
    }
    if (variant?.media) showMedia($('[data-gallery]', section), variant.media);
    if (changeUrl && !window.Shopify?.designMode) {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url);
    }
    section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant || null } }));
  }
  function initProduct(section) {
    if (section.dataset.productInitialized) return;
    const variants = variantsFor(section);
    const selected = $('[data-variant-select]', section)?.value;
    if (!variants.length || !variants.some(v => String(v.id) === selected)) return;
    section.dataset.productInitialized = 'true';
    const fallback = $('[data-variant-fallback]', section);
    const groups = $('[data-option-groups]', section);
    if (fallback && groups && variants.every(v => Array.isArray(v.options))) { fallback.hidden = true; groups.hidden = false; }
    updateVariant(section, selected, false);
    $$('[data-bundle-offer]', section).forEach(offer => { offer.hidden = false; });
    const add = $('[data-main-product-form] [data-add-button]', section);
    const bar = $('[data-sticky-bar]', section);
    if (add && bar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { bar.classList.toggle('sticky-main-visible', entries[0].isIntersecting); }, { threshold: 0.4 });
      observer.observe(add); stickyObservers.set(section, observer);
    }
  }
  $$('[data-product-section]').forEach(initProduct);
  document.addEventListener('submit', event => {
    const bundle = event.target.closest('[data-bundle-form]');
    if (bundle && window.fetch) { event.preventDefault(); addBundle(bundle); return; }
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault(); addProduct(form, event.submitter);
  });
  document.addEventListener('click', event => {
    const target = event.target;
    const open = target.closest('[data-open-cart]');
    if (open && config.cartType === 'drawer' && $('dialog')?.showModal) { event.preventDefault(); openCart(open); return; }
    if (target.closest('[data-close-dialog]')) { closeCart(); return; }
    const dialog = target.closest('[data-cart-dialog]');
    if (target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeCart(); }
    const remove = target.closest('[data-remove-line]');
    if (remove) { event.preventDefault(); changeLine(remove.dataset.removeLine, 0); return; }
    const variant = target.closest('[data-variant-id]');
    if (variant) { const section = variant.closest('[data-product-section]'); const select = $('[data-variant-select]', section); if (select) { select.value = variant.dataset.variantId; select.dispatchEvent(new Event('change', { bubbles: true })); } return; }
    const thumb = target.closest('[data-media-target]');
    if (thumb) { showMedia(thumb.closest('[data-gallery]'), thumb.dataset.mediaTarget); return; }
    const quantity = target.closest('[data-quantity-change]');
    if (quantity) {
      const input = $('input', quantity.closest('.quantity'));
      if (input) { const delta = Number(quantity.dataset.quantityChange) * (Number(input.step) || 1); input.value = Math.min(Number(input.max) || Infinity, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + delta)); input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const sticky = target.closest('[data-sticky-buy]');
    if (sticky) { const form = $('[data-main-product-form]', sticky.closest('[data-product-section]')); if (form) { form.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); const focus = $('select:not([type=hidden]),[data-variant-id],button[type=submit]', form); if (focus && focus.getClientRects().length) focus.focus({ preventScroll: true }); } }
    const invalidSticky = target.closest('[data-sticky-add][type=button]');
    if (invalidSticky) {
      const form = $('[data-main-product-form]', invalidSticky.closest('[data-product-section]'));
      form?.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      $('[data-option-select]', form)?.focus({ preventScroll: true });
    }
    $$('[data-mobile-menu][open],.nav-dropdown[open],.filter-dropdown[open]').forEach(details => { if (!details.contains(target)) details.removeAttribute('open'); });
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-compare-range]')) event.target.closest('[data-comparison]').style.setProperty('--compare', `${event.target.value}%`);
    if (event.target.matches('[data-cart-dialog] [name=note]')) cartNoteDraft = event.target.value;
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('.sort-field select')) $$('details.filter-dropdown[open]', input.closest('form')).forEach(details => { details.open = false; });
    if (input.matches('[data-variant-select]') && !synchronisingVariant.has(input.closest('[data-product-section]'))) updateVariant(input.closest('[data-product-section]'), input.value);
    if (input.matches('[data-option-select]')) {
      const section = input.closest('[data-product-section]');
      const options = $$('[data-option-select]', section).map(select => select.value);
      const match = variantsFor(section).find(v => v.options?.every((value, i) => value === options[i]));
      updateVariant(section, match?.id, true, false);
      // Native form change notification keeps accelerated checkout/app observers in sync.
      const nativeSelect = $('[data-variant-select]', section);
      if (nativeSelect) {
        synchronisingVariant.add(section);
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        synchronisingVariant.delete(section);
      }
    }
    if (input.matches('[data-line-quantity]') && input.closest('[data-cart-dialog]')) { const qty = Number(input.value); if (Number.isInteger(qty) && qty >= 0) changeLine(input.dataset.line, qty); }
  });
  document.addEventListener('close', event => { if (event.target.matches('[data-cart-dialog]')) { document.body.classList.remove('dialog-open'); if (cartOpener?.isConnected) cartOpener.focus(); } }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') $$('[data-mobile-menu][open],.nav-dropdown[open],.filter-dropdown[open]').forEach(details => { details.removeAttribute('open'); $('summary', details)?.focus(); }); });
  document.addEventListener('shopify:section:load', event => {
    $$('[data-comparison]', event.target).forEach(el => el.style.setProperty('--compare', `${$('[data-compare-range]', el)?.value || 50}%`));
    $$('[data-product-section]', event.target).forEach(initProduct);
  });
  document.addEventListener('shopify:section:unload', event => {
    $$('[data-product-section]', event.target).forEach(section => stickyObservers.get(section)?.disconnect());
  });
  window.addEventListener('pageshow', () => $$('[data-product-section]').forEach(section => {
    const selected = $('[data-variant-select]', section)?.value;
    if (selected) updateVariant(section, selected, false);
  }));
})();
